import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import { ActionInterface } from "../../Interface/ActionInterface";
import { TaskTemplateInterface } from "../../Entity/Entities/Task/TaskTemplateInterface";

export default function* taskTemplateDelete(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.GLOBAL_TASK_TEMPLATE_DELETE_REQUEST
    });

    yield call(Http.delete, `task-templates/${action.payload?.taskTemplate.id}`);

    const taskTemplate: TaskTemplateInterface = action.payload?.taskTemplate.reinitialize({
      removed: true
    });

    yield put({
      type: Constants.GLOBAL_TASK_TEMPLATE_DELETE_SUCCESS,
      payload: {
        taskTemplate: taskTemplate
      }
    });

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.GLOBAL_TASK_TEMPLATE_DELETE_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchTaskTemplateDelete() {
  yield takeEvery(Constants.GLOBAL_TASK_TEMPLATE_DELETE_START, taskTemplateDelete);
}
